import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(timezone);

export default function getTimeZone(): string {
  return dayjs.tz.guess();
}
